import { Vue } from 'vue-property-decorator'

export const variableType = () => {
  return {
    CONSUMER_UNIT_DATA: { key: 50490001, label: Vue.prototype.$gettext('VARIABLE_TYPE.50490001') },
    ORGANIZATION: { key: 50490002, label: Vue.prototype.$gettext('VARIABLE_TYPE.50490002') },
    FINANCE: { key: 50490003, label: Vue.prototype.$gettext('VARIABLE_TYPE.50490003') },
    CONTROL: { key: 50490004, label: Vue.prototype.$gettext('VARIABLE_TYPE.50490004') },
    CONCESSION_CONTRACT_TARIFF: { key: 50490005, label: Vue.prototype.$gettext('VARIABLE_TYPE.50490005') },
    OTHER: { key: 50490099, label: Vue.prototype.$gettext('VARIABLE_TYPE.50490099') }
  }
}
